import React from 'react';
import { GoogleMap, withGoogleMap } from 'react-google-maps';

const BlockedMap = withGoogleMap((props: any) => {
  return (
    <GoogleMap
      center={{
        lat: -34.8833,
        lng: -56.1667,
      }}
      defaultOptions={{
        draggable: false,
        gestureHandling: 'greedy',
        disableDefaultUI: true,
        zoom: 12,
        minZoom: 12,
        maxZoom: 12,
        streetViewControl: false,
        rotateControl: false,
        panControl: false,
        mapTypeControl: false,
      }}
    />
  );
});

export default BlockedMap;
